import { Component } from "@angular/core";
import { CommonModule, AsyncPipe } from "@angular/common";
import { AiProcessingService } from "src/app/services/ai-processing.service";
import { combineLatest, map } from "rxjs";

@Component({
  selector: "app-ai-fab",
  templateUrl: "./ai-fab.component.html",
  styleUrls: ["./ai-fab.component.scss"],
  standalone: true,
  imports: [CommonModule, AsyncPipe],
})
export class AiFabComponent {
  readonly vm$ = combineLatest([
    this.ai.taskState$,
    this.ai.config$,
  ]).pipe(
    map(([taskState, config]) => ({
      taskState,
      config,
      isComplete: taskState === "complete",
    })),
  );

  constructor(public ai: AiProcessingService) {}
}
